import { AppState } from 'Store'

const getPatents = (state: AppState) => state.registratorCabinet.patents.commonPatents.patents

export const commonPatentsSelector = {
	getPatents,
}
